import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import BlitzEntryForm from './BlitzEntryForm';
import BlitzAPI from '../../../api/BlitzAPI';
import { handleFormErrors } from '../../form/utils';

class BlitzEntryCreate extends Component {
  constructor(props) {
    super(props);
    this.parseEntryFromUrl = this.parseEntryFromUrl.bind(this);
    this.state = {
      loadParseUrl: false,
    };
  }
  handleSubmit(values) {
    return BlitzAPI.postEntry({ entry: values }).catch(
      handleFormErrors,
    );
  }

  parseEntryFromUrl(url) {
    if (url) {
      this.setState({ loadParseUrl: true });
      BlitzAPI.parseEntryFromUrl({ url }).then(
        (response) => {
          this.setState({ loadParseUrl: false });
          this.setState({ entry: Object.assign(response.data.data, { is_blitz: true }) });
        },
      ).catch(() => {
        this.setState({ loadParseUrl: false });
      });
    }
  }
  render() {
    const { params } = this.props;
    return (
      <div>
        <h1 className="create-header">Create New Entry</h1>

        <BlitzEntryForm
          onSubmit={this.handleSubmit}
          parseEntryFromUrl={this.parseEntryFromUrl} // Must be in parent
          loadParseUrl={this.state.loadParseUrl} // Must be in parent
          initialValues={this.state.entry || {
            show_mobile: true,
            show_web: true,
            type: params.type,
            publish_date: moment(),
            source_id: 11,
            is_blitz: true,
          }}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
}

BlitzEntryCreate.propTypes = {
  params: PropTypes.object,
};

export default connect(
  mapStateToProps,
)(BlitzEntryCreate);



// WEBPACK FOOTER //
// ./src/cms/entry/blitz/BlitzEntryCreate.js